var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 108 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8A62F7",
    fillOpacity: 0.8,
    d: "M9 9.862c4.97-4.97 13.03-4.97 18 0L44.999 27.86c4.97 4.97 4.97 13.029 0 18-4.97 4.97-13.03 4.97-18 0L9 27.86c-4.97-4.97-4.97-13.029 0-18M45 9.862c4.97-4.97 13.03-4.97 18 0L80.999 27.86c4.97 4.97 4.97 13.029 0 18-4.97 4.97-13.03 4.97-18 0L45 27.86c-4.97-4.97-4.97-13.029 0-18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#612DF5",
    fillOpacity: 0.9,
    d: "M63 9.862c-4.97-4.97-13.03-4.97-18 0L27.001 27.86c-4.97 4.97-4.97 13.029 0 18 4.97 4.97 13.03 4.97 18 0L63 27.86c4.97-4.97 4.97-13.029 0-18M99 9.862c-4.97-4.97-13.03-4.97-18 0L63.001 27.86c-4.97 4.97-4.97 13.029 0 18 4.97 4.97 13.03 4.97 18 0L99 27.86c4.97-4.97 4.97-13.029 0-18"
  })));
};
export default SvgLogo;